import React, { useEffect, useState } from "react";
import { withRouter } from "react-router-dom";
import Routes from "./Routes";
import * as BosIdentityServices from "./data/BosWebServices/BosIdentityServices";
import * as AppConfig from "./logic/GlobalAppConfig";
import ContentLoadingBOS from "components/ContentLoadingBos";
import GlobalHotKeys from "./GlobalHotKeys";
import GlobalAppDisable from "components/GlobalAppDisable";
import { ApplicationIdleMessage, BosServerUnavailableMessage } from "./components/ApplicationMessages";
//import { closeSession } from "components/BosSessionFromUrl";
import { loadLocale } from "./logic/LocaleManager";
import { loadTheme } from "./logic/ThemeManager";
import { useForceUpdate } from "./ForceUpdate";

//Externals
import compose from "recompose/compose";
import IdleTimer from 'react-idle-timer'

//Shared layouts
import DashboardLayout from "./layouts/Dashboard/Dashboard";

//Redux
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as bosUserActions from "redux/actions/bosUserActions";
import * as dataSegmentActions from "redux/actions/dataSegmentActions";
import * as appStateActions from "redux/actions/appStateActions";
//import * as sessionActions from "redux/actions/sessionActions";

const idleTimeoutInMS = 1000 * 60 * 15;  // 15 mins

function WebWorkspace(props) {
  const { bosUserAuthToken, theme, bosServerUnavailable, appIdle, /* openSessions, currentDataSegment, */ currentDataViewLanguageCode, currentUILanguageCode } = props;
  const [isLoading, setIsLoading] = useState(true);
  const forceUpdate = useForceUpdate();

  //DISABLE DEFAULT BROWSER CONTEXTMENU
  document.oncontextmenu = function (e) {
    e.preventDefault();
    return false;
  }

  useEffect(() => {
    loadLocale(currentUILanguageCode, currentDataViewLanguageCode);
    forceUpdate();
  }, [currentDataViewLanguageCode, currentUILanguageCode]);

  useEffect(() => {
    loadTheme(theme);
  }, []);   //don't act on changes of theme

  useEffect(() => {
    async function fetchData() {
      try {
        let dataSegmentId = AppConfig.getConfigDataGlobalDataSegmentId();
        let authorizeResult = await BosIdentityServices.fetchAuthorize(bosUserAuthToken, dataSegmentId, dataSegmentId);
        props.dataSegmentActions.setConfigDataSegment(
          {
            newAuthToken: authorizeResult.token,
            newDataSegmentId: dataSegmentId,
          });
        setIsLoading(false);
      }
      catch (error) {
        console.error("Config Data Authorize Error:", error);
        props.dataSegmentActions.clearConfigDataSegment();
        props.history.push("/logout/-2");
        setIsLoading(false);
      }
    }

    setIsLoading(true);
    if (bosUserAuthToken) {
      fetchData();
    }
    else {
      setIsLoading(false);
    }

  }, [bosUserAuthToken]);

  // useEffect(() => {
  //   const cleanupOnUnload = () => {
  //     console.log("UNLOAD detected! Closing open Sessions", openSessions);
  //     openSessions.forEach(session => closeSession(props.sessionActions, currentDataSegment.authToken, session));
  //     return null;
  //   };

  //   window.addEventListener('beforeunload', cleanupOnUnload);
  //   return () => window.removeEventListener('beforeunload', cleanupOnUnload);
  // }, [openSessions]);

  const onIdle = (e) => {
    console.log("app gone idle", e);
    props.appStateActions.setApplicationIdle(true);
  };

  const onEndIdle = () => {
    console.log("end app idle");
    props.appStateActions.setApplicationIdle(false);
  };

  return (
    <GlobalHotKeys>
      <IdleTimer
        element={document}
        onIdle={onIdle}
        debounce={500}
        timeout={idleTimeoutInMS}
      />
      <GlobalAppDisable isActive={bosServerUnavailable || appIdle}>
        {appIdle
          ? <ApplicationIdleMessage action={onEndIdle} />
          : <BosServerUnavailableMessage />
        }
      </GlobalAppDisable>
      {isLoading
        ? <ContentLoadingBOS />
        : (
          <DashboardLayout>
            <Routes />
          </DashboardLayout>
        )
      }
      {/* this is where dialogs are rendered */}
      <div id='modal-root' />
    </GlobalHotKeys>
  );
}

function mapStateToProps(state, ownProps) {
  return {
    bosUserAuthToken: state.bosUser.authToken,
    bosServerUnavailable: state.appState.bosServerUnavailable,
    appIdle: state.appState.appIdle,
    theme: state.appSettings.theme,
    currentUILanguageCode: state.appState.uiLanguageIsoCode,
    currentDataViewLanguageCode: state.appState.dataViewLanguageIsoCode,
    //currentDataSegment: state.dataSegments.currentDataSegment,
    //openSessions: state.sessions.openSessions,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    bosUserActions: bindActionCreators(bosUserActions, dispatch),
    dataSegmentActions: bindActionCreators(dataSegmentActions, dispatch),
    appStateActions: bindActionCreators(appStateActions, dispatch),
    //sessionActions: bindActionCreators(sessionActions, dispatch)
  };
}

export default compose(
  withRouter,
  connect(
    mapStateToProps,
    mapDispatchToProps
  )
)(WebWorkspace);
